import {InstantQuoteApi} from "@natomas-org/villa-nexus-client";
import {AxiosInstance} from "axios";
import {getAxiosInstance} from "../setup";

export class InstantQuoteService {
  private axiosInstance;
  private client;

  constructor(axiosInstance: AxiosInstance) {
    this.axiosInstance = axiosInstance;
    // @ts-ignore
    this.client = new InstantQuoteApi(undefined, undefined, this.axiosInstance);
  }

  async get(productId: string, latitude: number, longitude: number) {
    try {
      const response = await this.axiosInstance.get(
        `/instant-quote/items/${productId}/search`,
        {
          params: {
            latitude,
            longitude
          }
        }
      );
      return response.data;
    } catch (error: any) {
      // 404 is expected when site work cannot be determined for this location
      if (error?.response?.status === 404) {
        return null; // Return null to indicate no site work data available
      }
      
      // Log and throw other unexpected errors
      console.error("InstantQuoteService.get error:", error);
      throw error;
    }
  }
}

export const getInstantQuoteService = async () => {
  // InstantQuoteService does not require authentication to use
  const axiosInstance = await getAxiosInstance({ skipAuth: true });
  return new InstantQuoteService(axiosInstance);
};
